import { useTranslation } from "react-i18next";
import { FormDatePicker } from "@/shared/Components";
import styles from "./styles.module.scss";

export const DueDateSelect = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <p className={styles.label}>{t("notesPage.due")}</p>
      <FormDatePicker
        placeholder={t("common.selectDate")}
        format={{
          format: "DD-MM-YYYY",
          type: "mask",
        }}
        name={"currentNote.dueDate"}
      />
    </div>
  );
};
